// @ts-check

import Vue from 'vue'
import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import i18n from '@/plugins/i18n'
import _module from '@/store/base/module'

const initApis = {
  wallet: { api: 'M2001CoinsService.initWallet' },
  chatroom: { api: 'M1002ChatRecipientService.getTotalUnreadCount' },
  cart: { api: 'M2701ShoppingCartService.read' },
  role: { api: 'M0101RoleService.getRoles' },
  reportCategory: { api: 'M0601CategoryService.getReportCategories' }
}

function initCommits (commit, data) {
  commit('M2001Coins/SET_WALLET', data.wallet.output, { root: true })
  commit('M0901Chatroom/SET_TOTAL_UNREAD_COUNT', data.chatroom.output, { root: true })
  commit('M2701ShoppingCart/SET_ROWS', data.cart.output, { root: true })
  commit('M0001User/SET_ROLE_ITEMS', data.role.output, { root: true })
  commit('Report/SET_CATEGORIES', data.reportCategory.output, { root: true })
}

const module = {
  state: {
    init: null,
    logged: !!localStorage.getItem('logged'),
    user: {},
    existUser: {}
  },

  getters: {
    getInit (state) {
      return state.init
    },

    getLogged (state) {
      return state.logged
    },

    getUser (state) {
      return state.user
    },

    getUserRole (state) {
      return state.user.role_code ?? null
    },

    getUserPermissions (state) {
      return state.user.permissions ?? null
    },

    getExistUser (state) {
      return state.existUser
    }
  },

  mutations: {
    INIT (state) {
      if (state.logged && ObjArrUtils.isEmpty(state.user)) {
        localStorage.removeItem('logged')
        this.commit('Notification/SET_NOTIFY_WARNING', {
          text: i18n.t('auth.sessionTimeout')
        })
      }
      state.init = true
    },
    LOGIN (state, payload) {
      state.user = payload
      localStorage.setItem('logged', '1')
    },
    LOGOUT (state) {
      state.user = {}
      localStorage.removeItem('logged')
    },
    EXIST_USER (state, payload) {
      state.existUser = payload
    }
  },

  actions: {
    login: ({ commit }, authInfo) => {
      return ApiUtils.auth({
        data:
        {
          user: { api: 'AuthService.userLogin', input: authInfo },
          ...initApis
        }
      })
        .then((data) => {
          if (data.user.output) {
            commit('LOGIN', data.user.output)
            initCommits(commit, data)
          }
          localStorage.removeItem('init')
          return data.user.output
        })
    },
    register: ({ commit }, input) => {
      return ApiUtils.auth({ data: { auth: { api: 'AuthService.register', input } } })
        .then((data) => {
        })
    },
    logout: ({ commit }) => {
      return ApiUtils.auth({ data: { auth: { api: 'AuthService.userLogout' } } })
        .then((data) => {
          localStorage.removeItem('init')
          Vue.prototype.$resetState()
          commit('LOGIN', data.auth.output)
        })
    },
    init: async ({ commit, state }, forceUpdate) => {
      let data
      // if is debug mode, remove init cache
      const debugCacheJSON = localStorage.getItem('init')
      const debugCache = JSON.parse(debugCacheJSON)
      if (
        !forceUpdate &&
        process.env.NODE_ENV === 'development' &&
        debugCacheJSON &&
        debugCache.user.output.role_code !== 'V'
      ) {
        console.log('Use init cache (local dev only)')
        data = debugCache
      } else {
        data = await ApiUtils.auth({
          data:
          {
            user: { api: 'AuthService.getCurrentUser' },
            ...initApis
          }
        }).catch((error) => {
          state.init = false
          throw error
        })
      }
      try {
        // if data not object
        if (typeof data !== 'object') {
          throw new Error('init data is not object')
        }

        if (data.user.output) {
          commit('LOGIN', data.user.output)
          initCommits(commit, data)
        }
        commit('INIT')
        localStorage.setItem('init', JSON.stringify(data))
        return data?.user.output
      } catch (error) {
        localStorage.removeItem('init')
        // refresh page
        window.location.reload()
      }
    },
    snsLogin: ({ commit, state }, input) => {
      return ApiUtils.auth({
        data: {
          auth: { api: 'AuthService.snsLogin', input },
          ...initApis
        }
      })
        .then((data) => {
          if (data.auth.output) {
            commit('LOGIN', data.auth.output.user)
            initCommits(commit, data)
          }
          return data.auth.output
        })
    },
    bindEmail: ({ commit, state }, input) => {
      return ApiUtils.auth({ data: { auth: { api: 'AuthService.bindEmail', input } } })
        .then((data) => {
          if (data.auth.output.success) {
            commit('EXIST_USER', data.auth.output.user)
          } else {
            commit('EXIST_USER', data.auth.output.user)
          }
          return data.auth.output.success
        })
    },
    verifiedLogin: ({ commit, state }, input) => {
      return ApiUtils.auth({
        data: {
          auth: { api: 'AuthService.verifiedLogin', input },
          ...initApis
        }
      })
        .then((data) => {
          commit('LOGIN', data.auth.output)
          initCommits(commit, data)
          commit('EXIST_USER', {})
          return data.auth.output
        })
    },
    setUserLocale: ({ commit, state }, input) => {
      return ApiUtils.auth({ data: { auth: { api: 'AuthService.setUserLocale', input } } })
        .then((data) => {
          return data.auth.output
        })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
